<template>
  <div
    class="wt2-dashboard-wochit-storyboards wt2-dashboard-discover wt2-breakpoints -storyboards"
    :class="{
      'no-transition': !listTransition,
    }"
  >
    <div class="-storyboards-with-filter">
      <div class="-storyboards-filter-box">
        <div class="wt2-text-l2 -filter-label">FILTERS</div>

        <storyboards-aspect-ratio-selector
          :aspectRatios="filters.aspectRatios"
          @aspect-ratio-selected="changeAspectRatiosFilter"
        />

        <wt-collapse v-model="collapsibleModel" :accordion="false">
          <wt-collapse-item title="TOPICS" name="WT_COLLAPSIBLE_TOPICS">
            <dashboard-storyboards-categories
              :myTemplatesTab="false"
              @update-category-id="changeCategoriesFilter"
            />
          </wt-collapse-item>
        </wt-collapse>
      </div>

      <div class="-content">
        <discover-tab-filtering-bar
          :filters="filters"
          :show-drop-down="false"
          @on-change="onFilterChange"
        />

        <div class="-loader" v-show="isFetchingStoryboards">
          <div class="wt-dashboard-loader">
            <div class="wt-loader" />
          </div>
        </div>

        <wt-continuous-pagination
          v-if="!isFetchingStoryboards || !isFetchingWithReset"
          :on-next-page="onNextPage"
          class="-scrollable"
        >
          <div class="wt2-discover-container">
            <template v-if="!(isFetchingStoryboards && !videosClone.length)">
              <div
                v-if="isEmptyStoryboards"
                class="wt2-story-previews-empty-state -empty-state-box -storyboards"
              >
                <div class="-centered">
                  <img src="/resources/img/empty_no_results.png" />
                  <div class="-title">
                    {{ 'dashboardDiscover.empty2title' | culture }}
                  </div>
                  <div class="-message">
                    {{ 'dashboardDiscover.empty2subtitle' | culture }}
                  </div>
                </div>
              </div>
              <template v-else>
                <transition-group
                  tag="ul"
                  name="wt2-slide-from-top"
                  :appear="false"
                  :css="listTransition"
                  :class="['wt2-story-previews', 'list-inline', '-storyboards']"
                >
                  <template v-for="(video, i) in videosClone">
                    <storyboard-preview-item
                      v-if="!video.expanded && !video.dummy"
                      :key="video.id"
                      :story="video"
                      :show-add-button="isImpededTemplatizer"
                      :is-duplicating="isDuplicatingTemplate(video.id)"
                      @select="selectStoryboard(i)"
                      @add="addToMyTemplates(video)"
                    />
                    <li
                      v-else-if="video.dummy"
                      :key="video.id"
                      class="-dummy"
                    />
                    <expanded-gallery-item
                      v-else
                      :key="video.id"
                      :left="left"
                      tag="li"
                      @close="selectStoryboard(-1)"
                      :video="selectedStoryboard"
                    >
                      <expanded-storyboard
                        :storyboard="selectedStoryboard"
                        :removeFeatures="removeFeatures(selectedStoryboard)"
                        :is-duplicating="
                          isDuplicatingTemplate(selectedStoryboard.id)
                        "
                        :myTemplatesTab="false"
                        @action="execute"
                      />
                    </expanded-gallery-item>
                  </template>
                </transition-group>
              </template>
            </template>
          </div>
        </wt-continuous-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import app from 'app';
import StoryboardPreviewItem from './StoryboardPreviewItem.vue';
import DiscoverTabFilteringBar from './DiscoverTabFilteringBar.vue';
import DashboardStoryboardsCategories from './DashboardStoryboardsCategories.vue';
import StoryboardsAspectRatioSelector from './StoryboardsAspectRatioSelector.vue';
import ExpandedGalleryItem from './ExpandedGalleryItem.vue';
import ExpandedStoryboard from './ExpandedStoryboard.vue';
import wtVideoInformation from 'components/modals/types/wtVideoInformation';
import wtMassProduce from 'components/modals/types/wtMassProduce/wtMassProduce.component.vue';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { DuplicateController } from 'c/DuplicateController';

export default {
  name: 'dashboard-storyboards',

  components: {
    StoryboardPreviewItem,
    DiscoverTabFilteringBar,
    ExpandedGalleryItem,
    DashboardStoryboardsCategories, // myTemplatesTab
    StoryboardsAspectRatioSelector,
    ExpandedStoryboard,
  },

  data() {
    return {
      listTransition: true,
      isCopied: false,
      collapsibleModel: ['WT_COLLAPSIBLE_TOPICS'],
      duplicatingTemplates: [],
    };
  },

  created() {
    const urlParams = new URLSearchParams(window.location.search);
    this.SET_DEFAULT_STORYBOARD_FILTERS({ myTemplatesTab: false });
    this.$store.state.dashboard.storyboards = [];
    if (urlParams.get('categoryId')) {
      this.setStoryboardsFiltersCategories({ id: urlParams.get('categoryId') });
      app.navigate('dashboard/storyboards', { trigger: false });
    }
    Promise.all([
      this.FETCH_STORYBOARD_CATEGORIES(),
      this.INIT_STORYBOARD_BRANDS(),
    ]).then(() => {
      this.refreshCurrentList();
    });
  },

  beforeMount() {
    const unwatch = this.$watch('videos', (newVal) => {
      if (newVal && newVal.length) {
        this.calcItemDimensions();
        unwatch();
      }
    });
  },

  mounted() {
    window.addEventListener('resize', this.onResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  watch: {
    filters: {
      handler() {
        this.disableTransitions();
      },
      deep: true,
    },
    isFetchingStoryboards(newVal) {
      if (!newVal) {
        this.calcItemDimensions();
      }
    },
    selectedOrganizationId() {
      this.refreshCurrentList();
    },
  },

  computed: {
    ...mapGetters([
      'storyboardCategoryById',
      'indexOfSelectedStoryboard',
      'indexOfSelectedMyTeamStoryboard',
    ]),
    ...mapGetters('user', ['selectedProgrammers', 'isImpededTemplatizer']),
    ...mapState({
      selectedOrganizationId: (state) => state.user.selectedOrganizationId,
      filters: (state) => state.dashboard.storyboardsFilters,
      galleryItem: (state) => state.dashboard.galleryItem,
      videos: (state) => state.dashboard.storyboards,
    }),

    videoUrl() {
      return app.generatePublishUrl(this.selectedStoryboard.id);
    },

    videoUrlMyTeam() {
      return app.generatePublishUrl(this.selectedMyTeamStoryboard.id);
    },

    isFetchingStoryboards() {
      return this.$store.getters.fetching.storyboards.value;
    },

    isFetchingWithReset() {
      return this.$store.getters.fetching.storyboards.reset;
    },

    isEmptyStoryboards() {
      return (
        this.$store.state.dashboard.hasEmpty.storyboards &&
        !this.isFetchingStoryboards
      );
    },

    showProgrammerDropdown() {
      return app.programmers.length > 1;
    },

    left() {
      // TODO: remove hard coded values
      return (
        Math.round(this.galleryItem.width) * this.indexOfVideoInRow +
        this.galleryItem.width / 2 +
        20
      );
    },

    leftMyTeam() {
      // TODO: remove hard coded values
      return (
        Math.round(this.galleryItem.width) *
          this.indexOfSelectedMyTeamStoryboard +
        this.galleryItem.width / 2 +
        20
      );
    },

    selectedStoryboard() {
      let rv = null;
      if (this.indexOfSelectedStoryboard >= 0) {
        rv = Object.assign({}, this.videos[this.indexOfSelectedStoryboard]);
      }
      return rv;
    },

    videosClone() {
      let arr = [];
      let i = 0;
      if (this.indexOfExpandedItemInList < 0) {
        arr = this.videos.concat();
      } else {
        while (i < this.indexOfExpandedItemInList) {
          if (this.videos[i]) {
            arr.push(this.videos[i]);
          } else {
            arr.push({
              expanded: false,
              dummy: true,
              id: this.lineNumber + '_' + i,
            });
          }
          i++;
        }
        arr.push({ expanded: true, id: this.lineNumber });
        while (i < this.videos.length) {
          arr.push(this.videos[i]);
          i++;
        }
      }
      return arr;
    },

    lineNumber() {
      if (this.indexOfSelectedStoryboard < 0) {
        return -1;
      } else {
        return Math.floor(
          this.indexOfSelectedStoryboard / this.galleryItem.numberInRow
        );
      }
    },

    indexOfExpandedItemInList() {
      if (this.indexOfSelectedStoryboard < 0) {
        return -1;
      } else {
        return (this.lineNumber + 1) * this.galleryItem.numberInRow;
      }
    },

    indexOfVideoInRow() {
      if (this.indexOfSelectedStoryboard < 0) {
        return -1;
      } else {
        return this.indexOfSelectedStoryboard % this.galleryItem.numberInRow;
      }
    },
  },

  methods: {
    ...mapActions([
      'FETCH_STORYBOARD_CATEGORIES',
      'UPDATE_STORYBOARD',
      'EDIT_STORYBOARD',
    ]),
    ...mapActions([
      'fetchStoryboards',
      'INIT_STORYBOARD_BRANDS',
      'SET_DEFAULT_STORYBOARD_FILTERS',
    ]),

    ...mapMutations([
      'requestPause',
      'setIndexOfSelectedStoryboard',
      'setIndexOfSelectedMyTeamStoryboard',
      'setGalleryItemDetails',
      'setStoryboardsFiltersCategories',
      'setStoryboardsFiltersAspectRatios',
    ]),

    isDuplicatingTemplate(videoId) {
      return this.duplicatingTemplates.indexOf(videoId) >= 0;
    },

    massProduce(storyboard) {
      app.showModal({
        type: 'big',
        component: wtMassProduce,
        showCloseButton: false,
        closeOnEscape: false,
        closeOnClickOut: false,
        componentPropsData: {
          storyboard: storyboard,
        },
      });
    },

    async addToMyTemplates(video) {
      if (this.duplicatingTemplates.indexOf(video.id) >= 0) {
        return;
      }

      this.requestPause();

      const needConfirmation = !(
        app.remoteStash.get('hideAdd2MyTemplatesConfirm') ?? false
      );
      if (needConfirmation) {
        const response = await app.dialog.confirm({
          type: app.dialog.types.CONFIRM_3,
          title: app.culture.storyboards.add2MyTemplates,
          description:
            'This action will add this template to your custom templates, and will take a few minutes.',
          checkboxLabel: app.culture.confirmPopup.doNotShowAgain,
          buttonYesText: 'Ok',
          buttonNoText: 'Cancel',
          showCheckbox: true,
        });

        if (response.action) {
          if (response.metadata.checkboxValue) {
            app.remoteStash.set('hideAdd2MyTemplatesConfirm', true);
          }
        } else {
          return;
        }
      }

      this.duplicatingTemplates.push(video.id);
      app.api.producedStoryTemplates
        .addToMyTemplates({
          sourceStoryId: video.id,
          newTitle: video.title,
          destProgrammerId: app.programmers.first().get('id'),
          storyStartPoint: app.storyStartPoint.STORYBOARD,
          brandId: video.brandId,
          themeId: video.themeId,
        })
        .then(() => {
          app.notificationController.push({
            text: `Template "${video.title}". Expect to see it in your template gallery in a few minutes.`,
            type: 'SUCCESS',
            timeout: 2500,
          });
        })
        .catch((e) => {
          console.error('Failed to add to my templates', e);
          app.dialog.error({
            type: app.dialog.types.ERROR_1,
            title: 'Failed to duplicate template',
            description: 'Error: ' + e.error + '<br/>',
            showContactCsm: true,
          });
        })
        .finally(() => {
          this.duplicatingTemplates = _.without(
            this.duplicatingTemplates,
            video.id
          );
        });
    },

    changeCategoriesFilter({ id, multipleSelection }) {
      this.setStoryboardsFiltersCategories({ id, multipleSelection });
      this.refreshCurrentList();
    },

    changeAspectRatiosFilter({ ar }) {
      this.setStoryboardsFiltersAspectRatios({ ar });
      this.refreshCurrentList();
    },

    canDelete(storyboard) {
      if (!storyboard) {
        return false;
      }
      const relatedProgrammers = tk.context.relatedProgrammerList.map(
        (p) => p.id
      );
      const intersection = _.intersection(
        storyboard.sharedProgrammerIds,
        relatedProgrammers
      );
      return !!intersection.length;
    },

    refreshCurrentList(options) {
      this.$store.getters.fetching.storyboards.value = true;
      this.$store.getters.fetching.storyboards.reset = true;
      this.selectStoryboard(-1);
      return this.fetchStoryboards({ ...options, wochitTemplates: true });
    },

    disableTransitions() {
      this.listTransition = false;
      setTimeout(() => {
        this.listTransition = true;
      }, 1000);
    },

    onFilterChange() {
      this.disableTransitions();
      this.setIndexOfSelectedStoryboard(-1);
      this.setIndexOfSelectedMyTeamStoryboard(-1);
      this.refreshCurrentList();
    },

    onNextPage() {
      this.$store.getters.fetching.storyboards.reset = false;
      this.fetchStoryboards({ fetchMore: true, wochitTemplates: true });
    },

    selectStoryboard(index) {
      const indexOfExpandedItem = _.findIndex(
        this.videosClone,
        (v) => _.isObject(v) && v.expanded
      );
      const newIndex =
        indexOfExpandedItem >= 0 && index > indexOfExpandedItem
          ? index - 1
          : index;
      if (this.indexOfSelectedStoryboard === newIndex) {
        this.setIndexOfSelectedStoryboard(-1);
      } else {
        this.setIndexOfSelectedStoryboard(newIndex);
      }

      if (this.selectedStoryboard) {
        app.analytics('discover:preview', {
          videoID: this.selectedStoryboard.id,
        });
      }
    },

    onResize: _.debounce(
      function () {
        const fullscreenElement =
          document.fullscreenElement || document.webkitFullscreenElement;

        if (!fullscreenElement) {
          this.calcItemDimensions();
        }
      },
      10,
      { leading: true }
    ),

    calcItemDimensions() {
      this.$nextTick(() => {
        const ul = this.$el.querySelector('.-storyboards');
        if (!ul) {
          return;
        }
        const cs = window.getComputedStyle(ul);
        const numberInRow = +cs.getPropertyValue('--thumbnails-in-row') - 1;
        const padding = parseInt(cs.paddingLeft) + parseInt(cs.paddingRight);
        const width = ul.parentElement.getBoundingClientRect().width - padding;
        const itemWidth = width / numberInRow;
        const itemHeight = ((itemWidth - 16) * 9) / 16 + 30; // TODO remove hardCoded value
        this.setGalleryItemDetails({
          numberInRow,
          padding,
          width: itemWidth,
          height: itemHeight,
        });
      });
    },

    copyStoryboard(story) {
      this.startFromTemplate({
        story,
        title: app.culture.makeCopyDialog.title,
        message: app.culture.makeCopyDialog.messageVideoTemplate,
        buttonText: app.culture.makeCopyDialog.buttonText,
        keepAsStoryboard: true,
        copyTitle: true,
        requireTitle: false,
        resetCategories: this.isImpededTemplatizer,
      });
    },

    useStoryboard(story) {
      this.startFromTemplate({
        story,
        title: app.culture.makeCopyDialog.titleUseThis,
        message: app.culture.makeCopyDialog.messageUseThis,
        buttonText: app.culture.makeCopyDialog.buttonTextVideoTemplate,
        keepAsStoryboard: false,
        showOrganizationList: false,
        copyTitle: false,
        requireTitle: true,
      });
    },

    startFromTemplate({
      story,
      message,
      title,
      buttonText,
      keepAsStoryboard,
      showOrganizationList = true,
      copyTitle,
      requireTitle,
      resetCategories = false,
    }) {
      this.requestPause();

      DuplicateController.openDialog({
        story,
        message,
        storyStartPoint: app.storyStartPoint.BACK_TO,
        showOrganizationList,
        title,
        buttonText,
        source: 'produced_page',
        isVideoTemplate: true,
        keepAsStoryboard,
        copyTitle,
        requireTitle,
        resetCategories,
      }).then((data) => {
        this.$emit('closepopup');

        if (data.changeOrg) {
          app.delayedSpinner.hide();
        } else {
          app.navigate('stories/' + data.storyId);
        }
      });
    },

    deleteTemplate({ id }) {
      this.requestPause();

      app.dialog
        .confirm({
          type: app.dialog.types.CONFIRM_3,
          title: app.culture.storyboards.deletePopupTitle,
          description: app.culture.storyboards.deletePopupDescription,
          buttonYesText: app.culture.storyboards.deletePopup,
        })
        .then((data) => {
          if (!data.action) {
            return;
          }
          this.$store.getters.fetching.storyboards.value = true;
          this.$store.getters.fetching.storyboards.reset = true;

          this.$store.commit('deleteTemplate', id);
          this.selectStoryboard(-1);

          app.api.producedStories
            .delete({ id })
            .fail(() => {
              console.error(`failed to delete template ${id}`);
              this.refreshCurrentList();
            })
            .done(() => {
              console.log(`template ${id} deleted successfully`);
              this.refreshCurrentList();
            });
        });
    },

    execute({ type, storyboard, data }) {
      this.requestPause();

      switch (type) {
        case 'info': {
          wtVideoInformation(storyboard, {
            canAdjustThumbnail: false,
          })
            .then(({ id, title, description, keywords, categoryIds }) => {
              this.UPDATE_STORYBOARD({
                storyId: id,
                title,
                description,
                categoryIds,
                keywords,
                shortcutEnabled: storyboard.shortcutEnabled,
                massProduceEnabled: storyboard.massProduceEnabled,
              });
            })
            .catch(() => {
              //
            });
          break;
        }
        case 'slack': {
          this.mixinShowViewInModal({
            type: 'small',
            component: 'wt-slack',
            componentPropsData: {
              video: storyboard,
              videoType: 'storyboard',
            },
          });
          break;
        }
        case 'publish': {
          this.UPDATE_STORYBOARD({
            storyId: storyboard.id,
            categoryIds: (storyboard.categories ?? []).map((c) => c.id),
            shortcutEnabled:
              typeof data.shortcut === 'boolean'
                ? data.shortcut
                : storyboard.shortcutEnabled,
            massProduceEnabled:
              typeof data.massProduce === 'boolean'
                ? data.massProduce
                : storyboard.massProduceEnabled,
          });
          break;
        }
        case 'edit': {
          app.dialog
            .confirm({
              type: app.dialog.types.CONFIRM_3,
              title: app.culture.storyboards.editThisStoryboard,
              description:
                app.culture.storyboards.editThisStoryboardDescription,
              buttonYesText: app.culture.storyboards.editThisStoryboardOk,
            })
            .then(async ({ action }) => {
              if (action) {
                app.delayedSpinner.show();
                const error = await this.EDIT_STORYBOARD(storyboard);
                if (error) {
                  app.dialog.error({
                    type: app.dialog.types.ERROR_1,
                    showContactCsm: false,
                    title:
                      app.culture.setAsStoryTemplateDialog
                        .storyboardBeingEditTitle,
                    description:
                      app.culture.setAsStoryTemplateDialog
                        .storyboardBeingEditDescription,
                  });
                  console.error(error);
                  app.delayedSpinner.hide();
                } else {
                  app.navigate('stories/' + storyboard.id);
                }
              }
            });
          break;
        }
        case 'useThisStoryBoard': {
          this.useStoryboard(storyboard);
          break;
        }
        case 'makeACopy': {
          this.copyStoryboard(storyboard);
          break;
        }
        case 'delete': {
          this.deleteTemplate(storyboard);
          break;
        }
        case 'massProduce': {
          this.massProduce(storyboard);
          break;
        }
        case 'btn_add2MyTemplates': {
          this.addToMyTemplates(storyboard);
          break;
        }
      }
    },

    removeFeatures(storyboard) {
      const isSameChannelId = _.isNumber(storyboard.channelId)
        ? this.$store.state.user.channelId === storyboard.channelId
        : true;
      const rv = [];

      if (app.rootStore.getters['user/isTemplateSpecialist']) {
        rv.push('link_makeACopy');
      } else {
        rv.push('publish', 'btn_makeACopy');
      }

      if (!app.linkedFieldsSchema) {
        rv.push('mass_produce');
      }

      if (!this.canDelete(storyboard)) {
        rv.push('link_delete');
        rv.push('btn_edit');
        rv.push('publish');
      }

      if (!isSameChannelId || !this.canDelete(storyboard)) {
        rv.push('link_info');
      }

      if (this.isImpededTemplatizer) {
        rv.push('btn_useThisStoryBoard', 'link_share_on_slack');
      } else {
        rv.push('btn_add2MyTemplates');
      }

      return _.uniq(rv);
    },
  },
};
</script>

<style lang="scss" scoped>
.wt2-dashboard-wochit-storyboards {
  padding-top: 15px;

  .-storyboards-filter-box {
    overflow-y: overlay;
  }

  .wt2-discover-filtering {
    padding-left: 20px;
  }

  .-filter-label {
    margin-left: 15px;
  }

  .-content {
    border-left: 1px solid rgba(0, 0, 0, 0.2);
  }
}
</style>
